(function() { module.exports = this["wp"]["plugins"]; }());